<template>
  <div
    class="background-section overflow-auto min-h-screen"
    :style="{
      background:
        'linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(' +
        require('@/assets/images/bg.png') +
        ')',
      backgroundAttachment: 'fixed',
      backgroundSize: 'cover'
    }"
  >
    <div class="h-screen flex-col flex-1 flex">
      <!-- header logo -->
      <div class="w-full text-right px-12 flex-none">
        <img
          src="@/assets/images/logo-corp.png"
          alt="Logo TM One"
          class="h-16 inline-block mt-3"
        />
      </div>

      <div class="py-4 max-w-screen-large mx-auto px-8 flex-1 w-full">
        <!-- content & menu -->
        <div
          class="w-full px-4 py-2 rounded-lg border bg-white shadow-lg h-full"
        >
          <Header />
          <slot />
        </div>
      </div>

      <div class="w-full py-5 px-16 flex">
        <Footer class="flex-1" />
        <div class="flex-1 text-right">
          <img src="/images/ecostruxure-logo.png" class="h-12 inline-block" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Footer from '@/components/Portal/Footer'
import Header from '@/components/Portal/Header'
export default {
  name: 'portalLayout',
  components: {
    Header,
    Footer
  }
}
</script>
<style lang="scss">
// @apply bg-gradient-to-r from-indigo-500 to-pink-700;

.max-w-screen-large {
  max-width: 1440px;
}
.grid-custom {
  display: grid;
  grid-template-columns: 80px repeat(4, minmax(200px, 1fr)) 80px;
  grid-template-rows: 80px 1fr 1fr 80px;
}
.background-section {
  height: 100%;
  background-repeat: repeat-x;
  background-color: #f1f2f3;
  background-size: cover;
}
</style>
